export const normalizeFilterId = (id) => String(id ?? "");

export const isSameFilterId = (left, right) =>
  normalizeFilterId(left) === normalizeFilterId(right);

export const normalizeCategoryFilter = (filter = {}) => ({
  parameterName: filter.parameterName,
  id: normalizeFilterId(filter.id),
});

export const normalizeCategoryFilters = (filters = []) =>
  (Array.isArray(filters) ? filters : [])
    .map(normalizeCategoryFilter)
    .filter((filter) => filter.parameterName && filter.id);

export const isCategoryFilterSelected = (selectedFilters, parameterName, id) =>
  selectedFilters.some(
    (filter) =>
      filter.parameterName === parameterName && isSameFilterId(filter.id, id),
  );

export const getValueByPath = (obj, name) => {
  if (!obj || !name) return undefined;
  return name
    .replace(/\[(\d+)\]/g, ".$1")
    .split(".")
    .reduce((acc, key) => acc?.[key], obj);
};

const normalizeKosherClassification = (value) =>
  value === "חלבי" ||
  value === "בשרי" ||
  value === "פרווה" ||
  value === "לא מוגדר"
    ? value
    : "לא מוגדר";

export const buildEntityCountMap = (categoryNode, parameterName, map = {}) => {
  if (!categoryNode) return map;

  if (Array.isArray(categoryNode.products)) {
    categoryNode.products.forEach((product) => {
      const entity = getValueByPath(product, parameterName);
      if (
        parameterName !== "kosherSupervision[0].classification" &&
        !entity?.id
      ) {
        return;
      }

      const key = normalizeFilterId(
        parameterName !== "kosherSupervision[0].classification"
          ? entity.id
          : normalizeKosherClassification(entity),
      );

      if (!key) return;

      if (!map[key]) {
        map[key] = {
          id:
            parameterName !== "kosherSupervision[0].classification"
              ? entity.id
              : key,
          name:
            parameterName !== "kosherSupervision[0].classification"
              ? entity.name
              : key,
          quantity: 1,
        };
      } else {
        map[key].quantity += 1;
      }
    });
  }

  if (Array.isArray(categoryNode.children)) {
    categoryNode.children.forEach((child) =>
      buildEntityCountMap(child, parameterName, map),
    );
  }

  return map;
};

export const filterCategoryTreeByParameter = (
  categoryNode,
  paramName,
  wantedIds,
) => {
  if (!categoryNode) return null;

  const normalizedWantedIds = wantedIds.map(normalizeFilterId);

  let filteredProducts = [];
  if (Array.isArray(categoryNode.products)) {
    filteredProducts = categoryNode.products.filter((product) => {
      const entity = getValueByPath(product, paramName);
      return (
        (entity &&
          entity.id &&
          normalizedWantedIds.some((wantedId) =>
            isSameFilterId(wantedId, entity.id),
          )) ||
        (paramName === "kosherSupervision[0].classification" &&
          normalizedWantedIds.some((wantedId) =>
            isSameFilterId(wantedId, normalizeKosherClassification(entity)),
          ))
      );
    });
  }

  let filteredChildren = [];
  if (Array.isArray(categoryNode.children)) {
    filteredChildren = categoryNode.children
      .map((child) =>
        filterCategoryTreeByParameter(child, paramName, normalizedWantedIds),
      )
      .filter(Boolean);
  }

  if (!filteredProducts.length && !filteredChildren.length) {
    return null;
  }

  return {
    ...categoryNode,
    products: filteredProducts,
    children: filteredChildren,
  };
};

export const applyCategoryFilters = (tree, filters = []) => {
  if (!tree) return tree;

  const normalizedFilters = normalizeCategoryFilters(filters);
  if (!normalizedFilters.length) return tree;

  let result = tree;
  const grouped = normalizedFilters.reduce((acc, { parameterName, id }) => {
    if (!acc[parameterName]) acc[parameterName] = [];
    acc[parameterName].push(id);
    return acc;
  }, {});

  Object.entries(grouped).forEach(([parameterName, ids]) => {
    if (!result) return;
    result = filterCategoryTreeByParameter(result, parameterName, ids);
  });

  return result ?? tree;
};
